import Page from 'components/Page'
import { CheckExerciseFormHero } from './Hero/index.js'
import { CheckExerciseFormWhoItsBuiltFor } from './WhoItsBuiltFor'
import { CheckExerciseFormReviews } from './Reviews'
import { CheckExerciseFormHowItWorks } from './HowItWorks'
import { CheckExerciseFormPricing } from './Pricing/index.js'
import { CheckExerciseFormGetApp } from './GetApp/index.js'
import { CheckExerciseFormFAQ } from './FAQ/index.js'
import { ToolsFAQ } from 'pages/Tools/components/ToolsFAQ'
import React from 'react'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { logEventFacebookPixelUtil } from 'modules/facebook/utils/logEvent/index.js'
import { FACEBOOK_PIXEL_EVENT } from 'modules/facebook/constants/index.js'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { createProfileAction } from 'modules/profile/redux/actions/create/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import { updateInterestFocusProfileAction } from 'modules/profile/redux/actions/updateInterestFocus/index.js'
import { PROFILE_INTEREST_FOCUS } from '@gymaholic/packages'

const messages = defineMessages({
  title: {
    id: 'CheckExerciseFormPages.title',
    defaultMessage: 'Check Your Exercise Form with AI - Gymaholic App'
  }
})

export default function CheckExerciseFormPages () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const dispatch = useDispatch()

  React.useEffect(() => {
    logEventFacebookPixelUtil(FACEBOOK_PIXEL_EVENT.VIEW_CONTENT, {
      content_name: 'Check Your Exercise Form Page',
      content_category: 'Landing'
    })

    dispatch(createProfileAction())
    dispatch(updateInterestFocusProfileAction(PROFILE_INTEREST_FOCUS.WORKOUTS))
  }, [])

  return (
    <Page
      shouldNotHavePadding
      style={{
        textAlign: isSmallScreen
          ? 'center'
          : undefined
      }}
      title={formatMessageIntlUtil(intl, messages.title)}
    >
      <CheckExerciseFormHero />
      <CheckExerciseFormWhoItsBuiltFor />
      <CheckExerciseFormReviews />
      <CheckExerciseFormHowItWorks />
      <CheckExerciseFormPricing />
      <CheckExerciseFormGetApp />
      <CheckExerciseFormFAQ />
      <ToolsFAQ />
    </Page>
  )
}
